import classNames from "classnames";
import css from "./ScenarioStepTimeline.module.scss";

interface ScenarioStepTimelineProps {
    readonly steps: ReadonlyArray<string>;
    readonly activeIndex: number;
    readonly onSelectStep: (index: number) => void;
}

/**
 * The scenario builder's step tracker, laid out horizontally above the panel.
 *
 */
export const ScenarioStepTimeline: React.FC<ScenarioStepTimelineProps> = ({
    steps,
    activeIndex,
    onSelectStep
}: ScenarioStepTimelineProps) => (
    <div className={css["ScenarioStepTimeline"]} role="list">
        {steps.map((label, index) => {
            const isActive = index === activeIndex;
            return (
                <div
                    className={css["ScenarioStepTimeline-step"]}
                    key={label}
                    role="listitem"
                >
                    <button
                        type="button"
                        className={classNames(
                            css["ScenarioStepTimeline-item"],
                            {
                                [css["ScenarioStepTimeline-item-active"]]:
                                    isActive
                            }
                        )}
                        onClick={() => onSelectStep(index)}
                    >
                        <span
                            className={classNames(
                                css["ScenarioStepTimeline-number"],
                                {
                                    [css["ScenarioStepTimeline-number-active"]]:
                                        isActive
                                }
                            )}
                        >
                            {index + 1}
                        </span>
                        <span
                            className={classNames(
                                css["ScenarioStepTimeline-label"],
                                {
                                    [css["ScenarioStepTimeline-label-active"]]:
                                        isActive
                                }
                            )}
                        >
                            {label}
                        </span>
                    </button>
                    {index < steps.length - 1 && (
                        <span
                            className={css["ScenarioStepTimeline-connector"]}
                        />
                    )}
                </div>
            );
        })}
    </div>
);
